import loader from "../../Assets/json/spinner.json";
import Loader from "../Lottie";

const Fallback = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="w-32 h-32">
        <Loader loader={loader} />
      </div>
    </div>
  );
};

export default Fallback;
